/**
 * Un style de box du configurateur est un **modèle** : l'appliquer recopie ses
 * valeurs dans la box, qui devient autonome et se personnalise ensuite dans le
 * panel de droite. Rien n'est persisté qui dise quel modèle est actif — comme
 * la galerie de styles du site, la vignette surlignée se déduit des valeurs.
 */

/** Les valeurs d'un modèle, sans ce qui décrit le modèle lui-même. */
export function boxPropsFromStyle(style) {
  const { id, name, fromTmp, ...props } = style || {};
  return props;
}

/**
 * La box est-elle réglée exactement comme ce modèle ? Comparaison sur les clés
 * du modèle uniquement : ce que la box porte en plus ne la disqualifie pas.
 * Les objets (bordures, badges) sont comparés par leur sérialisation, comme
 * partout ailleurs pour ces sacs de valeurs simples.
 */
export function boxMatchesStyle(props, style) {
  const model = boxPropsFromStyle(style);
  return Object.keys(model).every((key) => {
    const a = model[key];
    const b = props?.[key];
    if (a && typeof a === 'object') return JSON.stringify(a) === JSON.stringify(b);
    return a === b;
  });
}

/**
 * Un style du configurateur par l'identifiant qu'une box référence. Un style
 * venu d'une section liée porte un suffixe (« 2_section_9_time_… », cf.
 * utils/styles.js) : on retombe sur son style d'origine, puis sur sa position.
 * `null` si rien ne correspond.
 */
export function findConfigurationStyle(styles, styleId) {
  const list = styles || [];
  if (styleId == null || styleId === '') return null;
  const fullId = String(styleId);
  const idPrefix = fullId.split('_')[0];
  return list.find((s) => String(s?.id) === fullId)
    || list.find((s) => String(s?.id) === idPrefix)
    || list.find((s) => String(s?.id || '').startsWith(`${idPrefix}_`))
    || list[parseInt(idPrefix, 10)]
    || null;
}
